export function starLog(...args: any[]) {
  if (startsWithLocalhost8080()) {
    console.log(...args);
  }
}

function startsWithLocalhost8080(): boolean {
  const url = window.location.href;
  return url.startsWith("http://localhost:8080/");
}
